import ApiService from '../../../../../services/ApiService'
import moment from 'moment'
import Utils from '../../../../../Utils/FormatDate'

import ManageSupplier from '../../../Suppliers/components/ManageSupplier.vue'
export default {
  props: {
    title: String,
    serviceOrderId: Number,
    unidadeId: Number,
    serviceCost: Object,
    disabled: Boolean,
  },

  components: {
    ManageSupplier,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getSuppliers()
    this.getAvoidedCostNatures()

    this.user = JSON.parse(localStorage.getItem('user'))

    if (this.serviceCost) {
      this.getCost()
      this.isEditing = true
    }
  },

  watch: {
    search(newValue) {
      this.searchStockItems(newValue)
    },

    'currentServiceCost.hasNoStockLink'(hasNoStockLink) {
      if (this.isEditing) return

      // Os dois modos usam campos distintos, então limpa o que não se aplica mais.
      if (hasNoStockLink) {
        this.stockExit = {
          exitDate: moment().format('YYYY-MM-DD HH:mm'),
        }
        this.stockItems = []
      } else {
        this.currentServiceCost.itemName = ''
        this.currentServiceCost.quantity = null
        this.currentServiceCost.unitaryValue = 0
      }
    },
  },

  data: () => ({
    dialogKey: false,
    supplierDialog: false,
    requestDateTimeError: false,
    step: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    supplierLoading: false,
    firstValid: false,
    error: false,
    dialog: false,
    institutionId: null,
    supplierId: null,
    suppliers: [],
    useInternalTeam: true,
    useSupplier: false,
    currentServiceCost: {
      id: 0,
      costValue: 0,
      costType: null,
      invoiceNumber: '',
      costDate: null,
      description: '',
      AvoidedCostNatureId: null,
      hasNoStockLink: false,
      itemName: '',
      quantity: null,
      unitaryValue: 0,
    },
    stockItems: [],
    stockItemLoading: false,
    search: '',
    searchTimeout: null,
    stockExit: {
      exitDate: moment().format('YYYY-MM-DD HH:mm'),
    },
    costTypes: [
      'Custo material',
      'Custo serviços',
      'Custo evitado',
      'Custo logístico',
    ],
    costTypeMap: {
      'Custo material': 0,
      'Custo serviços': 1,
      'Custo evitado': 2,
      'Custo logístico': 3,
    },
    costValueRules: [(v) => !!v || 'Valor custo é requerido'],
    invoiceNumberRules: [
      (v) => !!v || 'Nª da nota é requerido',
      (v) => v.length <= 20 || 'Nº da nota deve ter no máximo 20 caracteres',
    ],
    costTypeRules: [(v) => v != -1 || 'Tipo do custo é requerido'],
    itemNameRules: [
      (v) => !!v || 'Nome do item é requerido',
      (v) => (v || '').length <= 200 || 'Nome do item deve ter no máximo 200 caracteres',
    ],
    descriptionRules: [(v) => !!v || 'Descrição é requerida'],
    apiService: new ApiService(),
    avoidedCostNatures: [],
  }),

  computed: {
    stockItem() {
      if (!this.stockExit || !this.stockExit.stockItemId) return {}

      return this.stockItems.find((x) => x.id == this.stockExit.stockItemId)
    },

    itemUnitIsUnidade() {
      if (this.stockExit && this.stockExit.stockItemId && this.stockItems) {
        const selectedItem = this.stockItems.find(
          (item) => item.id === this.stockExit.stockItemId
        )
        if (!selectedItem || !selectedItem.unit) {
          return true
        }
        return selectedItem.unit === 'Unidade'
      }
      return true
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    preventDot(event) {
      if (event.key === '.') {
        event.preventDefault()
      }
      if (event.key === ',') {
        event.preventDefault()
      }
    },

    closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        this.getSuppliers()
      }
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    selectInternalTeam(value) {
      this.useInternalTeam = value
      if (value) {
        this.useSupplier = false
        this.supplierId = null
      }
    },

    selectSupplierOption(value) {
      this.useSupplier = value
      if (value) {
        this.useInternalTeam = false
      }
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    setDescription() {
      if (this.stockExit && this.stockExit.stockItemId) {
        this.currentServiceCost.description = this.stockItems.find(
          (x) => x.id == this.stockExit.stockItemId
        ).name
      }
    },

    close() {
      this.$emit('close')
    },

    async getCost() {
      await this.apiService
        .get(`serviceOrderCost/${this.serviceCost.id}`)
        .then((response) => {
          this.currentServiceCost = response.content
          this.supplierId = this.currentServiceCost.supplierId
          this.currentServiceCost.costType =
            this.costTypes[this.currentServiceCost.costType]
          this.currentServiceCost.costValue = this.currentServiceCost.costValue
          this.stockExit = this.currentServiceCost.stockExit
            ? this.currentServiceCost.stockExit
            : {}

          if (this.currentServiceCost.hasNoStockLink) {
            this.stockItems = []
          } else if (this.stockExit.stockItem) {
            this.stockItems = [this.stockExit.stockItem]
          }

          if (this.currentServiceCost.costType === 'Custo logístico') {
            this.useInternalTeam = !!this.currentServiceCost.isInternalTeam
            this.useSupplier = !this.useInternalTeam
          }
        })
    },

    async getAvoidedCostNatures() {
      this.apiService
        .get(`AvoidedCostNature/list/${this.institutionId}`)
        .then((response) => {
          this.avoidedCostNatures = response.content
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar as naturezas dos custos evitados')
        })
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.$emit('confirm')
      }
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    async getStockItems(search = '') {
      this.stockItemLoading = true

      const params = search ? { search } : {}

      await this.apiService
        .get(`stockItem/list/unidade/${this.unidadeId}`, params)
        .then((response) => {
          this.stockItems = response.content
          this.stockItemLoading = false
        })
        .catch(() => {
          this.stockItemLoading = false
        })
    },

    searchStockItems(searchValue) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        if (searchValue && searchValue.trim().length > 2) {
          this.getStockItems(searchValue)
        } else if (!searchValue || !searchValue.trim()) {
          this.stockItems = this.stockExit.stockItem
            ? [this.stockExit.stockItem]
            : []
        }
      }, 300)
    },

    async submit() {
      this.stockExit.exitDate = moment(this.currentServiceCost.costDate).format(
        'yyyy-MM-DDTHH:mm:ss'
      )

      if (!this.currentServiceCost.costDate) {
        this.$toast.warning('Selecione uma data para prosseguir')
        return
      }
      const isLogisticCost =
        this.currentServiceCost.costType === 'Custo logístico'

      const serviceOrderCost = {
        Id: this.currentServiceCost.id,
        CostValue: this.currentServiceCost.costValue,
        CostType: this.costTypeMap[this.currentServiceCost.costType],
        InvoiceNumber: this.currentServiceCost.invoiceNumber,
        SupplierId:
          isLogisticCost && this.useInternalTeam ? null : this.supplierId,
        Description: this.currentServiceCost.description,
        costDate: moment(this.currentServiceCost.costDate).format(
          'yyyy-MM-DDTHH:mm:ss'
        ),
        ServiceOrderId: this.serviceOrderId,
        AvoidedCostNatureId: this.currentServiceCost.AvoidedCostNatureId,
        IsInternalTeam: isLogisticCost ? this.useInternalTeam : false,
      }

      if (this.currentServiceCost.costType == 'Custo material') {
        if (this.currentServiceCost.hasNoStockLink) {
          // Item sem vínculo com estoque: nenhuma saída de estoque é gerada.
          serviceOrderCost.HasNoStockLink = true
          serviceOrderCost.ItemName = this.currentServiceCost.itemName
          serviceOrderCost.Quantity = parseFloat(
            this.currentServiceCost.quantity
          )
          serviceOrderCost.UnitaryValue = this.currentServiceCost.unitaryValue
        } else {
          this.stockExit.registrationUserId = this.user.id
          serviceOrderCost.stockExit = this.stockExit
        }
      }

      let url = 'serviceOrderCost/add'

      if (this.isEditing) {
        url = 'serviceOrderCost/edit'
      }

      this.loading = true
      await this.apiService
        .post(url, serviceOrderCost)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },
}
